module.exports = __webpack_public_path__ + "static/media/share-icon.55bb5cfd.svg";